module.exports = {
  'pages': {
    'registration': {
      'description': 'Sollten Sie noch keine Login-Daten haben, können Sie sich einfach mit Ihrer Annahmestellennummer (AST-Nummer) registrieren. Im Anschluss daran wird Ihnen umgehend eine E-Mail zugestellt.\n',
      'title': 'Ihre Lernportal Registrierung',
    }
  },
  'placeholder': {
    'actionCode': 'Annahmestellennummer'
  }
};
